function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useCallback } from 'react';
import styled from 'styled-components';
import '../../Link/index.js';
import { MENU_PADDING } from './constants.js';
import { jsx } from 'react/jsx-runtime';
import Link from '../../Link/Link.js';
function MobileMenuItem({
  navLink,
  onClick,
  children,
  activeTab
}) {
  let ariaControls = {};
  // Dont add aria controls for explore/prices nav item.
  if (navLink?.key !== 'prices') {
    ariaControls = {
      'aria-expanded': activeTab?.toLocaleLowerCase() === navLink?.key.toLocaleLowerCase(),
      'aria-controls': 'global-nav-mobile-sublinks',
      role: 'button'
    };
  } else {
    ariaControls = {};
  }
  const handleKeyPress = useCallback(event => {
    if (event.key === 'Enter' && onClick) {
      onClick();
    }
    if (event.key === 'Escape' && onClick) {
      onClick();
    }
  }, [onClick]);
  const handleOnKeyDown = useCallback(e => handleKeyPress(e), [handleKeyPress]);
  if (navLink?.url && !navLink.subLinks) {
    return /*#__PURE__*/jsx(Link, {
      to: navLink.url,
      testID: `mobile-menu-${navLink.key === 'prices' ? 'price' : navLink.key}-link`,
      children: /*#__PURE__*/jsx(ItemWrapper, {
        children: children
      })
    });
  }
  return /*#__PURE__*/jsx(ItemWrapper, _objectSpread(_objectSpread({
    onClick: onClick,
    "data-testid": `mobile-menu-${navLink?.key}-item`,
    tabIndex: 0,
    onKeyDown: handleOnKeyDown
  }, ariaControls), {}, {
    children: children
  }));
}
const ItemWrapper = styled.div`
  padding: ${MENU_PADDING};
  display: flex;
  align-items: center;
`;
export { ItemWrapper, MobileMenuItem as default };
//# sourceMappingURL=MobileMenuItem.js.map
